import { setupRedux } from '@exodus/redux-dependency-injection';

import createDependencies from './dependencies.js';
import { UI_CONFIG_DEFINITION } from '../../constants/ui-config.js';
import createLogger from '../../utils/logger.js';

const config = { uiConfig: UI_CONFIG_DEFINITION };

export const { selectors, createHandleEvent, ioc, reducers, initialState } =
  setupRedux({
    reducers: {},
    initialState: {},
    dependencies: createDependencies(config),
    createLogger,
  });
